import React from 'react';
import { formatDate } from '../helpers/dates';

export default function FormattedDate(props: { date: string | Date | nundefined; dateType?: 'dateOnly'; }) {
	const normalized = props.date ? new Date(props.date) : null;
	if (!normalized || isNaN(normalized.getTime()))
		return null;
	
	return <span>{formatDate(normalized, { dateType: props.dateType })}</span>
}
